<template><div class="d-flex justify-center">

<div class="b_naoword i_english px-2" style="max-width: 600px">
	<div v-if="!have_lang">
		<div :class="$css.title"> {{ 'Comparing Nao with other conlangs' | t }} </div>

		<p>
			How is Nao different from other conlangs? What makes it unique? You can find it out in the articles below!
		</p>

		<div class="d-flex justify-space-around">
			<v-btn v-for="lang in languages" @click="$router.push('/comparison/' + lang)"> {{ lang }} </v-btn>
		</div>
	</div>

	<div v-else>
		<component :lang="$route.params.lang" class="px-3" :is="Comparison || $g.NotTranslated"></component>

		<div class="d-flex justify-center pa-5">
			<v-btn @click="$router.push('/comparison')">Comparison with other conlangs</v-btn>
		</div>
	</div>
</div>

</div></template>

<script>

import i18n from '@/i18n'
import Vue from 'vue'

export default {
	components: {},
	data() {
		return {
			languages: ['Esperanto', 'Lojban', 'Tokipona']
		}
	},
	methods: {

	},
	created() {

	},
	computed: {
		Comparison() {
			return i18n.choose[this.$store.state.language].components.Comparison || i18n.choose['en'].components.Comparison;
		},
		have_lang() {
			return !!this.$route.params.lang;
		}
	}
}
</script>
